import moment from 'moment';

const defaultDateFormat = (date) => moment(date).format('MM-DD-YYYY');
const payloadDateFormat = (date) => moment(date).format('YYYY-MM-DD[T]HH:mm:ss');

export default { defaultDateFormat, payloadDateFormat };
